import { makeStyles } from '@material-ui/core'

export const useSelectStyles = makeStyles(theme => ({
  menuItemHidden: {
    display: 'none'
  },
  selectPlaceHolder: {
    color: '#b7b9be'
  },
  icon: {
    right: 8
  }
}))
